module.exports = __webpack_public_path__ + "static/banner-4c285959fab8b8cc080f2be53ed44c7e.jpg";